import {Dispatch, SetStateAction} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';
import {LOAN_AMOUNT_MAX, LOAN_AMOUNT_MIN} from './LoanSliderFilter';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const LoansInfoBtmSheet = ({isOpen, setIsOpen}: IProps) => {
  return (
    <BottomSheet
      onDismiss={() => setIsOpen(false)}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 p-8 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-6 left-6"
          onClick={() => setIsOpen(false)}
        />

        <div className="flex flex-col items-center justify-center gap-2">
          <i className="text-5xl text-farm-shop-500 icon-namereport1 " />
          <p className="flex justify-center text-lg font-bold text-gray-950">
            وام و اعتبار
          </p>

          <div className="flex flex-col gap-1 text-sm">
            <span className="mb-1 font-medium text-gray-800 text-md ">
              اعتبار مزرعه
            </span>
            <span className="text-gray-700 text-md">
              تا سقف {LOAN_AMOUNT_MIN} میلیون تومان اعتبار دریافت می‌کنید و مبلغ
              خرید را پس از برداشت محصول پرداخت می‌کنید.
            </span>

            <span className="mt-3 mb-1 font-medium text-gray-800 text-md ">
              وام بانکی
            </span>
            <span className="text-gray-700 text-md">
              تا سقف {LOAN_AMOUNT_MAX} میلیون تومان وام بانکی برای خرید دریافت
              می‌کنید و اقساط را ماهانه به بانک بازپرداخت می‌کنید.
            </span>
          </div>
        </div>

        <div className="flex justify-end w-full mt-4">
          <Button
            type="button"
            // className="w-full px-3 py-2 mt-1 text-white rounded-lg bg-farm-shop-500 text-md disabled:bg-gray-500"
            onClick={() => setIsOpen(false)}
          >
            متوجه شدم
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default LoansInfoBtmSheet;
